define('pdhighlights_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('pdhighlights_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/AAMS/AAMSPDPSerialLotFunctionality/1.0.1/', 'extensions/AAMS/AAMSPDPSerialLotFunctionality/1.0.1/', Handlebars);
});